module.exports = __webpack_public_path__ + "img/chat-manage-customer.90fa9555.svg";